import { Field, reduxForm, formValueSelector, reset } from 'redux-form'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import InputField from 'client/features/form/components/InputField.jsx'
import CheckboxField from 'client/features/form/components/CheckboxField.jsx'
import CheckboxesField from 'client/features/form/components/CheckboxesField.jsx'
import RadiosField from 'client/features/form/components/RadiosField.jsx'
import REGEXP from 'constant/REGEXP'
import REPORT from 'constant/REPORT'
import _ from 'lodash'

const validate = (values = {}) => {
    const errors = {}
    if (!values.email) errors.email = 'Champ requis'
    else if (!REGEXP.validations.email.test(values.email)) errors.email = 'Invalid format.'
    if (!values.firstName) errors.firstName = 'Champ requis'
    if (!values.lastName) errors.lastName = 'Champ requis'
    
    return errors
}

class UserForm extends Component {

    constructor() {
        super()
        this.state = { showHive: true } 
    }

    unSelectHives() {

    }

    setHive(values) {
        this.props.change('limitedHives', values)
    }

    render() {
        const { handleSubmit, pristine, submitting, error, initialValues, formValues, user, sendInvitation } = this.props
        
        return (
            <form onSubmit={ handleSubmit } className='form-horizontal m-t-10'>

                
                <div className='row'>
                    <div className='col-md-6 col-sm-6'>
                        { user.firstName } { user.lastName }
                    </div>
                    <div className='col-md-6 col-sm-6 text-right' style={{ marginTop: -22 }}>
                        {
                            !user.new && !user.validated && user.email &&
                                <button
                                    className='btn btn-custom btn-bordred waves-effect waves-light text-uppercase'
                                    type='button'
                                    disabled={ submitting }
                                    style={{ marginRight: 8 }}
                                    onClick={ sendInvitation }
                                >
                                    Ré-envoyer invitation
                                </button>
                        }
                        <button className='btn btn-custom btn-bordred waves-effect waves-light text-uppercase' type='submit' disabled={ submitting }>Sauver</button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6 col-sm-6'>
                        <Field name='firstName' component={ InputField } placeholder='Prénom...'/>
                    </div>
                    <div className='col-md-6 col-sm-6'>
                        <Field name='lastName' component={ InputField } placeholder='Nom...'/>
                    </div>
                </div>
                <Field name='email' component={ InputField } type='email' placeholder='Email...'/>
                
                {
                    initialValues && Object.keys(initialValues)[1] && 
                        <div>
                        <div className='row'>
                            <div className='col-md-12' style={{ marginBottom: 12 }}>
                                <Field
                                    name='language'
                                    component={ RadiosField }
                                    fields={ [{
                                        value: 'fr',
                                        label: 'Français'
                                    },
                                    {
                                    value: 'en',
                                    label: 'Anglais'
                                    }] }
                                    initialValue={ this.props.user.language || 'fr' }
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-4 col-sm-4'>
                                <Field name='weeklyReports' component={ CheckboxField } initialValues={ this.props.user.weeklyReports } boolean={ true } label='Rapports email hebdomadaires'/>
                            </div>
                            <div className='col-md-4 col-sm-4'>
                                <Field name='directReports' component={ CheckboxField } initialValues={ this.props.user.directReports } boolean={ true } label='Rapport email à chaque visite'/>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-4 col-sm-4'>
                                <Field name='admin' component={ CheckboxField } initialValues={ this.props.user.admin } boolean={ true } label='Logiciel'/>
                            </div>
                            <div className='col-md-4 col-sm-4'>
                                <Field name='disabled' component={ CheckboxField } initialValues={ this.props.user.disabled } boolean={ true } label='Désactivé'/>
                            </div>
                            <div className='col-md-4 col-sm-4'>
                                <Field name='limited' component={ CheckboxField } initialValues={ this.props.user.limited } boolean={ true } label='Limité'/>
                            </div>
                        </div>
                        </div>
                }
                {
                    initialValues && Object.keys(initialValues)[0] && formValues.limited &&
                        <div>
                            <h5>Limiter les types de visite</h5>
                            <Field
                                component={ CheckboxesField }
                                fields={ REPORT.types.map(type => ({
                                    ...type,
                                    label: type.label.fr
                                })) }
                                name='limitedTypes'
                                initialValues={ this.props.initialValues.limitedTypes }
                            /> 
                            <h5 style={ { marginTop: 22 } }>
                                Limiter les ruches
                                { /*<a className='btn btn-custom btn-xs' style={{ marginLeft: 8 }}>
                                    Tous
                                </a>
                                <a className='btn btn-custom btn-xs' onClick={ this.unSelectHives.bind(this) } style={{ marginLeft: 8 }}>
                                    Aucun
                                </a> */}
                            </h5>
                            {
                                this.props.clients && _.sortBy(this.props.clients.all, 'name').filter(client => client.hives && client.hives[0]).map(client => 
                                    <div key={ client._id } className='well'>
                                        { client.name }
                                        <Field
                                            component={ CheckboxesField }
                                            fields={ client.hives.map(hive => ({ ...hive, value: hive._id, label: hive.identifier })) }
                                            name='limitedHives'
                                            initialValues={ this.props.initialValues.limitedHives }
                                            selectAll={ false }
                                            label=' '
                                        /> 
                                    </div>
                                )
                            }
                        </div>
                }
                {
                    error ? <p className='error' id='login-error'>{ error }</p> : null
                }
            </form>
        )
    }
}

const selector = formValueSelector('user')

const mapStateToProps = (state, ownProps) => {
    return {
        //form: ownProps.name,
        formValues: {
            admin: selector(state, 'admin'),
            disabled: selector(state, 'disabled'),
            limited: selector(state, 'limited'),
            limitedHives: selector(state, 'limitedHives')
        },
        clients: state.client
    }
}

UserForm = reduxForm({
    form: 'user',
    validate,
    enableReinitialize: true
})(UserForm)

export default connect(mapStateToProps)(UserForm)


// WEBPACK FOOTER //
// ./src/client/features/users/containers/UserForm.jsx